import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const NoteWrapper = styled.div`
  display: block;

  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.huge};
  `}

  ${({ theme }) => media.sm`
    margin-bottom: ${theme.space.desktop.huge};
  `}
`
